import { Chip } from "@octopusdeploy/design-system-components";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { withTheme } from "~/components/Theme";
import { GitIcon } from "~/primitiveComponents/dataDisplay/Icon";
export const GitChip: React.FC<{
    enabled: boolean;
}> = ({ enabled }) => {
    return withTheme((theme) => {
        if (enabled) {
            return <Chip icon={<GitIcon style={{ color: themeTokens.color.icon.inverse, width: "18px", height: "18px" }}/>} label="Enabled" backgroundColor={theme.successText} labelColor={themeTokens.color.text.inverse}/>;
        }
    });
};
GitChip.displayName = "GitChip"
